import React, { useContext } from 'react'
import { Button } from 'antd'
// import FirstNumber from 'assets/images/new-images/numbers/1.svg'
// import SecondNumber from 'assets/images/new-images/numbers/2.svg'
// import ThirdNumber from 'assets/images/new-images/numbers/3.svg'
// import ForthNumber from 'assets/images/new-images/numbers/4.svg'
// import FifthNumber from 'assets/images/new-images/numbers/5.svg'
// import SixthNumber from 'assets/images/new-images/numbers/6.svg'
// import SeventhNumber from 'assets/images/new-images/numbers/7.svg'
// import EighthNumber from 'assets/images/new-images/numbers/8.svg'
// import NinthNumber from 'assets/images/new-images/numbers/9.svg'
// import TenthNumber from 'assets/images/new-images/numbers/10.svg'
// import ElevenNumber from 'assets/images/new-images/numbers/11.svg'
import CheckIconWhite from 'assets/images/new-images/check-icon-white.svg'
import { convertNumberToCommaSeparate } from 'utils/utilities'

import './pendingAdvisory.css'
import { AppContext } from 'AppContext'

const TermsConditionNew = ({ data, loading, onFinish }) => {
  const {
    state: {
      currentUser: { isNewAuaAdvisoryGenerate },
      isMobile,
    },
  } = useContext(AppContext)

  const productRecommended =
    data?.getPendingBookingAdvisory?.productRecommended || ''
  const isFinRakshak =
    productRecommended.toLowerCase().includes('rakshak') ||
    productRecommended.toLowerCase().includes('beta') ||
    productRecommended.toLowerCase().includes('finrakshak')

  const feeRate =
    data?.getPendingBookingAdvisory?.productAMC !== undefined &&
    data?.getPendingBookingAdvisory?.productAMC !== null &&
    data?.getPendingBookingAdvisory?.productAMC !== ''
      ? data?.getPendingBookingAdvisory?.productAMC
      : data?.getPendingBookingAdvisory?.productAnnual !== undefined &&
        data?.getPendingBookingAdvisory?.productAnnual !== null &&
        data?.getPendingBookingAdvisory?.productAnnual !== ''
      ? data?.getPendingBookingAdvisory?.productAnnual
      : ''

  if (isFinRakshak) {
    return (
      <div className='terms_page'>
        <div className='terms_page_title'>
          We are happy to see your interest in FinRakshak – Portfolio Beta Hedging Advisory
        </div>
        <div className='terms'>
          <div className='terms_details'>
            <div className='terms_detail_box'>
              <div className='terms_text'>
                1. You have opted for <strong>FinRakshak – Portfolio Beta Hedging Advisory</strong>, which is provided in a <strong>non-discretionary advisory capacity</strong>. This means that all recommendations are advisory in nature, and the final investment and execution decisions shall remain solely with you.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                2. The advisory shall be based on the details of your existing portfolio comprising <strong>equity shares, mutual funds, or a combination of both</strong>, as shared by you from time to time.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                3. The primary objective of this advisory is to <strong>measure the beta of your portfolio</strong> and recommend suitable <strong>index-based hedging strategies</strong> to manage downside market risk.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                4. Based on the computed portfolio beta and prevailing market conditions, we shall advise on:
                <ul style={{ listStyleType: 'disc', paddingLeft: '24px', marginTop: '8px', marginBottom: '0px' }}>
                  <li>The <strong>extent of index hedge required</strong></li>
                  <li>The <strong>indicative Nifty index put option strike</strong></li>
                  <li>The <strong>approximate quantity</strong> required for hedging purposes</li>
                </ul>
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                5. Portfolio beta and hedge requirements shall be <strong>reviewed periodically</strong> and shall also be <strong>re-evaluated upon any material change</strong> in your portfolio composition or significant market movements.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                6. Hedging strategies are intended to <strong>reduce portfolio volatility and potential drawdowns during adverse market conditions</strong>. Such strategies involve a cost in the form of an option premium, which <strong>may marginally reduce net returns during strong market rallies</strong>, as the protective options may expire without value in rising markets.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                7. Investments in index options involve <strong>market and derivative risks</strong>, including the risk of loss of the entire option premium. Hedging strategies do not eliminate risk and may not fully protect against all market losses.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                8. Any illustrations, return expectations, or references (if shared) are <strong>indicative in nature</strong>, based on prevailing assumptions and market conditions, and <strong>do not constitute any assurance or guarantee of returns</strong>.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                9. The advisory fees applicable to this plan are approximately{' '}
                <span className='highlighted_text'>
                  {feeRate !== '' ? `${feeRate}%` : '%'}
                </span>{' '}
                <strong>per annum</strong>, exclusive of applicable statutory levies. Brokerage charges, taxes, duties, and option premiums are <strong>borne separately by the client</strong>.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                10. There is <strong>no lock-in period</strong> under this advisory. However, for meaningful risk management outcomes, the advisory is best evaluated over a <strong>medium- to long-term investment horizon</strong>.
              </div>
            </div>

            <div className='terms_detail_box'>
              <div className='terms_text'>
                11. All recommendations provided under this advisory are based on information shared by you and prevailing market conditions. <strong>Execution, timing, and implementation of recommendations remain the responsibility of the client</strong>, and we shall not be responsible for execution delays or deviations.
              </div>
            </div>

            <div className='term_note'>
              Let us know if you have any queries. We would like to help you with the same. Kindly send your confirmation after reading this mail so that we can proceed further.
            </div>
            <div
              className='verify_next_button'
              style={{
                marginRight: '18px',
                marginTop: `${isMobile && '20px'}`,
                marginBottom: isMobile ? '6dvh' : '2px',
              }}
            >
              <Button
                className='confirm-next-button'
                loading={loading}
                onClick={onFinish}
              >
                <img src={CheckIconWhite} alt='RightArrowIconBlack' />{' '}
                &nbsp;Confirm
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {!isNewAuaAdvisoryGenerate ? (
        <div className='terms_page'>
          <div className='terms_page_title'>
            We are happy to see your interest in Index Long Term Strategy
          </div>
          <div className='terms'>
            <div>A few feature of Index Long Term Strategy are as below:</div>
            <div className='terms_details'>
              <div className='terms_detail_box'>
                {/* <img src={FirstNumber} alt='FirstNumber' /> */}
                <div className='terms_text'>
                  1. This Strategy invests money in the Nifty index.
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={SecondNumber} alt='SecondNumber' /> */}
                <div className='terms_text'>
                  2. It is a combination of Equity ETFs, Futures, and Options.
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={ThirdNumber} alt='ThirdNumber' /> */}
                <div className='terms_text'>
                  3. You have selected the&nbsp;
                  <span className='highlighted_text'>
                    {data?.getPendingBookingAdvisory?.productRecommended}
                  </span>
                  .
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={ForthNumber} alt='ForthNumber' /> */}
                <div className='terms_text'>
                  {`4. You want to take ${
                    data?.getPendingBookingAdvisory?.productRecommended
                      ?.toLowerCase()
                      ?.includes('marathon')
                      ? `exposure`
                      : `AUA`
                  } of Rs.`}
                  <span className='highlighted_text'>
                    {convertNumberToCommaSeparate(
                      +data?.getPendingBookingAdvisory?.productExposure,
                    )}
                  </span>
                  .
                </div>
              </div>
              {data?.getPendingBookingAdvisory?.productRecommended
                ?.toLowerCase()
                ?.includes('basic', 'comfort') ? (
                <div className='terms_detail_box'>
                  {/* <img src={FifthNumber} alt='FifthNumber' /> */}
                  <div className='terms_text'>
                    5. You will invest&nbsp;
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                    &nbsp; in Basic Plan or{' '}
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productExposure *
                          (50 / 100)
                      )}
                    </span>
                    &nbsp; in Comfort Plan now. It indirectly means that you
                    will save interest on balance fund.
                  </div>
                </div>
              ) : data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('power', 'booster') ? (
                <div className='terms_detail_box'>
                  {/* <img src={FifthNumber} alt='FifthNumber' /> */}
                  <div className='terms_text'>
                    5. You will invest Equity or MF of{' '}
                    <span className='highlighted_text'>
                      {' '}
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productStock
                      )}
                    </span>{' '}
                    as as collateral &{' '}
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>{' '}
                    now.It indirectly means that you will save interest on{' '}
                    <span className='highlighted_text'>
                      Rs.{' '}
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.saveInterest
                      )}
                    </span>
                  </div>
                </div>
              ) : (
                <div className='terms_detail_box'>
                  {/* <img src={FifthNumber} alt='FifthNumber' /> */}
                  <div className='terms_text'>
                    5. You will invest{' '}
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                  </div>
                </div>
              )}

              <div className='terms_detail_box'>
                {/* <img src={SixthNumber} alt='SixthNumber' /> */}
                <div className='terms_text'>
                  6. The total annual cost is around&nbsp;
                  <span className='highlighted_text'>
                    {data?.getPendingBookingAdvisory?.productAnnual}%
                  </span>
                  .
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={SeventhNumber} alt='SeventhNumber' /> */}
                <div className='terms_text'>
                  7. There is no lock-in period of investment in this strategy,
                  still we recommend the logical period of investment is around
                  5 to 10 Years.
                </div>
              </div>
              {/* Add condition for marathon plan and change wording to full exposure */}
              <div className='terms_detail_box'>
                {/* <img src={EighthNumber} alt='EighthNumber' /> */}
                <div className='terms_text'>
                  {data?.getPendingBookingAdvisory?.productRecommended
                    ?.toLowerCase()
                    ?.includes('marathon')
                    ? `8. You also understand that you will have risk and return on
                  investment as below:`
                    : `8. You also understand that you will have risk and return on
                  full exposure as below:`}
                </div>
              </div>
              <div className='alphabet_text_box'>
                <div className='terms_detail_box' style={{ marginTop: '8px' }}>
                  <div>A.</div>
                  <div className='terms_text'>
                    {isFinRakshak ? 'Annual Hedging Cost:' : 'Annual Hedging & Financing Cost:'}&nbsp;
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productHedging}%
                    </span>
                  </div>
                </div>
                <div className='terms_detail_box' style={{ marginTop: '16px' }}>
                  <div>B.</div>
                  <div className='terms_text'>
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productHedging}%
                    </span>
                    &nbsp; + AMC&nbsp;
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productAMC}%
                    </span>
                    {data?.getPendingBookingAdvisory?.productRecommended
                      ?.toLowerCase()
                      ?.includes('marathon')
                      ? '= Total Annual Cost'
                      : '= Gross Total Cost'}
                    &nbsp;
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.grossTotal}%
                    </span>
                  </div>
                </div>
                {data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('marathon') ? (
                  ''
                ) : (
                  <div
                    className='terms_detail_box'
                    style={{ marginTop: '16px' }}
                  >
                    <div>C.</div>
                    <div className='terms_text'>
                      <span className='highlighted_text'>
                        {data?.getPendingBookingAdvisory?.grossTotal}%
                      </span>
                      &nbsp; -&nbsp;Interest saved&nbsp;
                      <span className='highlighted_text'>
                        {data?.getPendingBookingAdvisory?.productInterest}%
                      </span>
                      &nbsp;= Total Annual Cost&nbsp;
                      <span className='highlighted_text'>
                        {data?.getPendingBookingAdvisory?.productAnnual}%
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className='terms_detail_box'>
                {/* <img src={NinthNumber} alt='NinthNumber' /> */}
                <div className='terms_text'>
                  9. Please note that the above cost is indicative as per the
                  current market scenario & it may change from time to time.
                </div>
              </div>

              {data?.getPendingBookingAdvisory?.productRecommended
                ?.toLowerCase()
                ?.includes('power', 'booster') ? (
                <div className='terms_detail_box'>
                  {/* <img src={TenthNumber} alt='TenthNumber' /> */}
                  <div className='terms_text'>
                    10. Your payment schedule will be{' '}
                    <span className='highlighted_text'>
                      Rs.{' '}
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                    &nbsp;initially &&nbsp;
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productSIP
                      )}
                    </span>{' '}
                    as monthly SIP.
                  </div>
                </div>
              ) : data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('basic', 'comfort') ? (
                <div className='terms_detail_box'>
                  {/* <img src={TenthNumber} alt='TenthNumber' /> */}
                  <div className='terms_text'>
                    10. Your payment schedule will be{' '}
                    <span className='highlighted_text'>
                      Rs.{' '}
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                    &nbsp;initially &&nbsp;
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productSIP
                      )}
                    </span>{' '}
                    as monthly. This SIP will start from the next month in Basic
                    Plan or from 37th Month in Comfort Plan.
                  </div>
                </div>
              ) : data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('marathon') ? (
                <div className='terms_detail_box'>
                  {/* <img src={TenthNumber} alt='ElevenNumber' /> */}
                  <div className='terms_text'>
                    10. You will be charged{' '}
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productAMC}%{' '}
                    </span>{' '}
                    {/* only for marathon plan change ht value to Product AMC 2. numbering */}
                    as fees on additional investment.
                  </div>
                </div>
              ) : (
                <div className='terms_detail_box'>
                  {/* <img src={ElevenNumber} alt='ElevenNumber' /> */}
                  <div className='terms_text'>
                    11. You will be charged{' '}
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productAMC}%{' '}
                    </span>{' '}
                    as fees on additional AUA.
                  </div>
                </div>
              )}

              {/* <div className='terms_detail_box'>
              <img src={TenthNumber} alt='TenthNumber' />
              <div className='terms_text'>
                We advise you to invest above the gross total cost figure every
                month so that the above cost can be managed easily at the
                year-end on a monthly SIP basis.
              </div>
            </div> */}

              {/* <div className='terms_detail_box'>
              <img src={ElevenNumber} alt='ElevenNumber' />
              <div className='terms_text'>
                Your payment schedule will be&nbsp;
                <span className='highlighted_text'>
                  Rs.
                  {convertNumberToCommaSeparate(
                    +data?.getPendingBookingAdvisory?.productInitialInvestment
                  )}
                </span>
                &nbsp;initially &&nbsp;
                <span className='highlighted_text'>
                  Rs.
                  {convertNumberToCommaSeparate(
                    +data?.getPendingBookingAdvisory?.productSIP
                  )}{' '}
                </span>
                monthly.
              </div>
            </div> */}

              <div className='term_note'>
                Let us know if you have any queries. We would like to help you
                with the same. Kindly send your confirmation after reading this
                mail so that we can proceed further.
              </div>
              <div
                className='verify_next_button'
                style={{
                  marginRight: '18px',
                  marginTop: `${isMobile && '20px'}`,
                  marginBottom: isMobile ? '6dvh' : '2px',
                }}
              >
                <Button
                  // id='confirm-btn'
                  className='confirm-next-button'
                  loading={loading}
                  onClick={onFinish}
                >
                  <img src={CheckIconWhite} alt='RightArrowIconBlack' />{' '}
                  &nbsp;Confirm
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='terms_page'>
          <div className='terms_page_title'>
            We are happy to see your interest in Index Long Term Strategy
          </div>
          <div className='terms'>
            <div>A. few feature of Index Long Term Strategy are as below:</div>
            <div className='terms_details'>
              <div className='terms_detail_box'>
                {/* <img src={FirstNumber} alt='FirstNumber' /> */}
                <div className='terms_text'>
                  1. This Strategy invests money in the Nifty index.
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={SecondNumber} alt='SecondNumber' /> */}
                <div className='terms_text'>
                  2. It is a combination of Equity ETFs, Futures, and Options.
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={ThirdNumber} alt='ThirdNumber' /> */}
                <div className='terms_text'>
                  3. You have selected the&nbsp;
                  <span className='highlighted_text'>
                    {data?.getPendingBookingAdvisory?.productRecommended}
                  </span>
                  .
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={ForthNumber} alt='ForthNumber' /> */}
                <div className='terms_text'>
                  {`4. The total ${
                    data?.getPendingBookingAdvisory?.productRecommended
                      ?.toLowerCase()
                      ?.includes('marathon')
                      ? `exposure`
                      : `AUA`
                  }  till date is `}
                  <span className='highlighted_text'>
                    Rs.
                    {convertNumberToCommaSeparate(
                      +data?.getPendingBookingAdvisory?.currentAua
                    )}
                  </span>{' '}
                  {`, you are adding an ${
                    data?.getPendingBookingAdvisory?.productRecommended
                      ?.toLowerCase()
                      ?.includes('marathon')
                      ? `exposure`
                      : `AUA`
                  } of `}
                  <span className='highlighted_text'>
                    Rs.{' '}
                    {convertNumberToCommaSeparate(
                      +data?.getPendingBookingAdvisory?.productExposure
                    )}
                  </span>
                  {`, that will make Total ${
                    data?.getPendingBookingAdvisory?.productRecommended
                      ?.toLowerCase()
                      ?.includes('marathon')
                      ? `exposure`
                      : `AUA`
                  }
                  equal to `}
                  <span className='highlighted_text'>
                    Rs.{' '}
                    {convertNumberToCommaSeparate(
                      +data?.getPendingBookingAdvisory?.totalAua
                    )}
                  </span>
                </div>
              </div>
              {data?.getPendingBookingAdvisory?.productRecommended
                ?.toLowerCase()
                ?.includes('basic', 'comfort') ? (
                <div className='terms_detail_box'>
                  {/* <img src={FifthNumber} alt='FifthNumber' /> */}
                  <div className='terms_text'>
                    5. You will invest&nbsp;
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                    &nbsp; in Basic Plan or{' '}
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productExposure *
                          (50 / 100)
                      )}
                    </span>
                    &nbsp; in Comfort Plan now. It indirectly means that you
                    will save interest on balance fund.
                  </div>
                </div>
              ) : data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('power', 'booster') ? (
                <div className='terms_detail_box'>
                  {/* <img src={FifthNumber} alt='FifthNumber' /> */}
                  <div className='terms_text'>
                    5. You will invest Equity or MF of{' '}
                    <span className='highlighted_text'>
                      {' '}
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productStock
                      )}
                    </span>{' '}
                    as as collateral &{' '}
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>{' '}
                    now.It indirectly means that you will save interest on{' '}
                    <span className='highlighted_text'>
                      Rs.{' '}
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.saveInterest
                      )}
                    </span>
                  </div>
                </div>
              ) : (
                <div className='terms_detail_box'>
                  {/* <img src={FifthNumber} alt='FifthNumber' /> */}
                  <div className='terms_text'>
                    5. You will invest{' '}
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                  </div>
                </div>
              )}
              <div className='terms_detail_box'>
                {/* <img src={SixthNumber} alt='SixthNumber' /> */}
                <div className='terms_text'>
                  6. The total annual cost is around&nbsp;
                  <span className='highlighted_text'>
                    {data?.getPendingBookingAdvisory?.productAnnual}%
                  </span>
                  .
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={SeventhNumber} alt='SeventhNumber' /> */}
                <div className='terms_text'>
                  7. There is no lock-in period of investment in this strategy,
                  still we recommend the logical period of investment is around
                  5 to 10 Years.
                </div>
              </div>
              <div className='terms_detail_box'>
                {/* <img src={EighthNumber} alt='EighthNumber' /> */}
                <div className='terms_text'>
                  {data?.getPendingBookingAdvisory?.productRecommended
                    ?.toLowerCase()
                    ?.includes('marathon')
                    ? `8. You also understand that you will have risk and return on
                  investment as below:`
                    : `8. You also understand that you will have risk and return on
                  full exposure as below:`}
                </div>
              </div>
              <div className='alphabet_text_box'>
                <div className='terms_detail_box' style={{ marginTop: '8px' }}>
                  <div>A.</div>
                  <div className='terms_text'>
                    {isFinRakshak ? 'Annual Hedging Cost:' : 'Annual Hedging & Financing Cost:'}&nbsp;
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productHedging}%
                    </span>
                  </div>
                </div>
                <div className='terms_detail_box' style={{ marginTop: '16px' }}>
                  <div>B.</div>
                  <div className='terms_text'>
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productHedging}%
                    </span>
                    &nbsp; + AMC&nbsp;
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productAMC}%
                    </span>
                    {data?.getPendingBookingAdvisory?.productRecommended
                      ?.toLowerCase()
                      ?.includes('marathon')
                      ? '= Total Annual Cost'
                      : '= Gross Total Cost'}
                    &nbsp;
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.grossTotal}%
                    </span>
                  </div>
                </div>
                {data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('marathon') ? (
                  ''
                ) : (
                  <div
                    className='terms_detail_box'
                    style={{ marginTop: '16px' }}
                  >
                    <div>C.</div>
                    <div className='terms_text'>
                      <span className='highlighted_text'>
                        {data?.getPendingBookingAdvisory?.grossTotal}%
                      </span>
                      &nbsp; -&nbsp;Interest saved&nbsp;
                      <span className='highlighted_text'>
                        {data?.getPendingBookingAdvisory?.productInterest}%
                      </span>
                      &nbsp;= Total Annual Cost&nbsp;
                      <span className='highlighted_text'>
                        {data?.getPendingBookingAdvisory?.productAnnual}%
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className='terms_detail_box'>
                {/* <img src={NinthNumber} alt='NinthNumber' /> */}
                <div className='terms_text'>
                  9. Please note that the above cost is indicative as per the
                  current market scenario & it may change from time to time.
                </div>
              </div>
              {data?.getPendingBookingAdvisory?.productRecommended
                ?.toLowerCase()
                ?.includes('power', 'booster') ? (
                <div className='terms_detail_box'>
                  {/* <img src={TenthNumber} alt='TenthNumber' /> */}
                  <div className='terms_text'>
                    10. Your payment schedule will be{' '}
                    <span className='highlighted_text'>
                      Rs.{' '}
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                    &nbsp;initially &&nbsp;
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productSIP
                      )}
                    </span>{' '}
                    as monthly SIP for this new AUA.
                  </div>
                </div>
              ) : data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('basic', 'comfort') ? (
                <div className='terms_detail_box'>
                  {/* <img src={TenthNumber} alt='TenthNumber' /> */}
                  <div className='terms_text'>
                    10. Your payment schedule will be{' '}
                    <span className='highlighted_text'>
                      Rs.{' '}
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory
                          ?.productInitialInvestment
                      )}
                    </span>
                    &nbsp;initially &&nbsp;
                    <span className='highlighted_text'>
                      Rs.
                      {convertNumberToCommaSeparate(
                        +data?.getPendingBookingAdvisory?.productSIP
                      )}
                    </span>{' '}
                    monthly as SIP. This SIP will start from the next month in
                    Basic Plan or from 37th Month in Comfort Plan.
                  </div>
                </div>
              ) : (
                ''
              )}
              {data?.getPendingBookingAdvisory?.productRecommended
                ?.toLowerCase()
                ?.includes('relax') ? (
                <div className='terms_detail_box'>
                  {/* <img src={TenthNumber} alt='ElevenNumber' /> */}
                  <div className='terms_text'>
                    10. You will be charged{' '}
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productAMC}%{' '}
                    </span>{' '}
                    {/* only for marathon plan change ht value to Product AMC 2. numbering */}
                    as fees on additional AUA.
                  </div>
                </div>
              ) : data?.getPendingBookingAdvisory?.productRecommended
                  ?.toLowerCase()
                  ?.includes('marathon') ? (
                <div className='terms_detail_box'>
                  {/* <img src={TenthNumber} alt='ElevenNumber' /> */}
                  <div className='terms_text'>
                    10. You will be charged{' '}
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productAMC}%{' '}
                    </span>{' '}
                    {/* only for marathon plan change ht value to Product AMC 2. numbering */}
                    as fees on additional investment.
                  </div>
                </div>
              ) : (
                <div className='terms_detail_box'>
                  {/* <img src={ElevenNumber} alt='ElevenNumber' /> */}
                  <div className='terms_text'>
                    11. You will be charged{' '}
                    <span className='highlighted_text'>
                      {data?.getPendingBookingAdvisory?.productAMC}%{' '}
                    </span>{' '}
                    as fees on additional AUA.
                  </div>
                </div>
              )}

              {/* <div className='terms_detail_box'>
              <img src={TenthNumber} alt='TenthNumber' />
              <div className='terms_text'>
                We advise you to invest above the gross total cost figure every
                month so that the above cost can be managed easily at the
                year-end on a monthly SIP basis.
              </div>
            </div> */}
              {/* <div className='terms_detail_box'>
              <img src={ElevenNumber} alt='ElevenNumber' />
              <div className='terms_text'>
                Your payment schedule will be&nbsp;
                <span className='highlighted_text'>
                  Rs.
                  {convertNumberToCommaSeparate(
                    +data?.getPendingBookingAdvisory?.productInitialInvestment
                  )}
                </span>
                &nbsp;initially &&nbsp;
                <span className='highlighted_text'>
                  Rs.
                  {convertNumberToCommaSeparate(
                    +data?.getPendingBookingAdvisory?.productSIP
                  )}{' '}
                </span>
                monthly.
              </div>
            </div> */}
              <div className='term_note'>
                Let us know if you have any queries. We would like to help you
                with the same. Kindly send your confirmation after reading this
                mail so that we can proceed further.
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: `${isMobile ? 'flex-end' : 'center'}`,
                  marginTop: '10px',
                }}
              >
                <Button
                  // id='confirm-btn'
                  className='confirm-next-button'
                  loading={loading}
                  onClick={onFinish}
                >
                  <img src={CheckIconWhite} alt='RightArrowIconBlack' />{' '}
                  &nbsp;Confirm
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default TermsConditionNew
